/**
 * Image component that fetches via protected /api/uploads route.
 * Use when PROTECT_UPLOADS_ONLY is enabled or for sensitive images.
 */
import React from 'react';
import { useUploadBlobUrl } from '../hooks/useUploadBlobUrl';

const fill = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

export default function AuthImage({ filename, alt = '', ...props }) {
  const { url, loading, error } = useUploadBlobUrl(filename);

  if (!filename) {
    return null;
  }

  if (error) {
    return (
      <span
        {...props}
        style={{
          ...fill,
          ...props.style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0f0f0',
          color: '#999',
        }}
      >
        {alt || '?'}
      </span>
    );
  }

  if (loading || !url) {
    return (
      <span
        {...props}
        style={{
          ...fill,
          ...props.style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0,0,0,0.06)',
        }}
      />
    );
  }

  return <img src={url} alt={alt} {...props} style={{ ...fill, ...props.style }} />;
}
